/* 
Allows the connected wallet to withdraw unbonded LPT
*/
import { Stack, Text, Button } from "@mantine/core";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState } from "react";
import { ethers } from "ethers";
import SmartContractAction from "../components/SmartContractAction";

export default function WithdrawStakeButton(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const bondingManager = useBondingManager();
  const [thisErrMsg, setErrMsg] = useState("");

  const withdrawStake = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        setIsPending(true);
        const txn = await bondingManager.withdrawStake(props.lock.id);
        setTxn(txn.hash);
        await txn.wait();
        setIsFinished(true);
        props.refreshWallet();
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  if (props.thisRound < props.lock.round) {
    return (
      <Stack spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          styles={(theme) => ({
            label: {
              color: "#afb0b3",
            },
          })}
        >
          {(props.lock.amount / ethers.constants.WeiPerEther).toFixed(2)} LPT
          becomes unlocked in ~{props.lock.round - props.thisRound} days
        </Button>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={24}>
        <SmartContractAction
          isPending={isPending}
          txn={thisTxn}
          thisErrMsg={thisErrMsg}
          isFinished={isFinished}
          action={withdrawStake}
          actionMessage={
            "Withdraw " +
            (props.lock.amount / ethers.constants.WeiPerEther).toFixed(2) +
            " LPT"
          }
          finishedMessage={
            "Successfully withdrew " +
            (props.lock.amount / ethers.constants.WeiPerEther).toFixed(2) +
            " LPT!"
          }
          pendingMessage={"Withdrawing LPT..."}
        />
        {thisErrMsg != "" ? (
          <Text size="xl" fw={700}>
            The previous transaction failed with reason `{thisErrMsg}`
          </Text>
        ) : null}
      </Stack>
    );
  }
}
